import atomWithDebounce from "@/utils/atomWithDebounce";
import { PrimitiveAtom, atom } from "jotai";
import { atomEffect } from "jotai-effect";
import { focusAtom } from "jotai-optics";
import { modelAtom } from "./model";
import { PersistableModel } from "./types";

export const createFocusAtom = <T>(
  varName: string,
  intialValue: T,
  group: string = "general",
) =>
  focusAtom(modelAtom, (optic) =>
    optic
      .prop(group as keyof PersistableModel)
      .prop(varName as never)
      .valueOr(intialValue),
  );

export const inputisDebouncingMolecule = atom<PrimitiveAtom<boolean>[]>([]);
export const isInputDebouncingAtom = atom((get) => {
  return get(inputisDebouncingMolecule).some((atom) => get(atom));
});

export const generalInputAtom = <T>(
  varName: string,
  intialValue: T,
  group: string = "general",
) => {
  const debouceStore = atomWithDebounce<T>(undefined as T);
  const focusedAtom = createFocusAtom<T>(varName, intialValue, group);

  const updateEffect = atomEffect((get, set) => {
    const value = get(debouceStore.debouncedValueAtom);
    if (value === undefined) return;
    set(focusedAtom, value);
  });

  return atom<T, [T] | [T, boolean], void>(
    (get) => {
      get(updateEffect);
      return get(focusedAtom);
    },
    (get, set, update, setImmediate = false) => {
      const m = get(inputisDebouncingMolecule);
      if (!m.includes(debouceStore.isDebouncingAtom)) {
        set(inputisDebouncingMolecule, [...m, debouceStore.isDebouncingAtom]);
      }

      if (setImmediate) {
        set(focusedAtom, update);
        return;
      }
      set(debouceStore.debouncedValueAtom, update);
    },
  );
};
